import config from "config";
import React from "react";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";
import GoogleSignUpButton from "./GoogleSignUpButton";
import SignUpInput from "./SignUpInput";

const SectionWrapper = styled.div`
  position: relative;
  padding: 160px 0 200px;
  width: 100%;
  overflow: hidden;

  ${mediaMin.md`
    padding: 100px 0 200px;
  `};
`;

const SignInLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${mediaMin.md`
    flex-direction: row-reverse;
    max-width: 1200px;
    justify-content: flex-end;
    margin: 0 auto;
  `};
`;

const ContentsWrapper = styled.div`
  width: 100%;
  max-width: 780px;
  margin: 0 auto;
  z-index: 1;
  padding: 0 26px;

  ${mediaMin.md`
    padding: 0 32px 0 56px;
    margin: 0;
    min-height: 680px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  `}

  ${mediaMin.lg`
    padding: 0 0 0 56px;
  `};
`;

const MainCopySmall = styled.h1`
  text-align: center;
  line-height: 1.2;
  margin: 0 auto 40px;
  max-width: 210px;
  font-size: 32px;
  font-weight: 500;

  ${mediaMin.xs`
    margin-bottom: 48px;
    max-width: none;
    font-size: 48px;
    font-weight: 500;
  `};

  ${mediaMin.md`
    display: none;
  `}
`;

const MainCopyBig = styled.h1`
  line-height: 1.1;
  font-size: 56px;
  font-weight: 500;
  display: none;
  margin-bottom: 24px;

  ${mediaMin.md`
    display: block;
  `};
`;

const SubCopy = styled.p`
  font-size: 20px;
  line-height: 1.2;
  color: ${({ theme }) => theme.text};
  margin-bottom: 24px;
  display: none;

  ${mediaMin.md`
    display: block;
  `};
`;

const InputWrapper = styled.div`
  ${mediaMin.xs`
    width: 454px;
    margin: 0 auto;
  `}

  ${mediaMin.md`
    margin: 0;
  `};
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  margin: 23px 0;
  position: relative;
  background-color: ${({ theme }) => theme.subTextDivider};

  &:before {
    content: "or";
    width: 40px;
    height: 16px;
    position: absolute;
    left: 50%;
    top: -50%;
    transform: translate(-50%, -50%);
    background-color: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.subTextDivider};
    text-align: center;
  }

  ${mediaMin.lg`
    margin: 32px 0;
  `};
`;

const HighFiveImage = styled.img`
  object-fit: contain;
  width: 170px;
  margin: 0 auto 32px;

  ${mediaMin.xs`
    width: 200px;
  `};

  ${mediaMin.md`
    width: 306px;
    margin: 0;
  `};
`;

const RightCornerShapeImage = styled.img`
  width: 264px;
  display: none;
  position: absolute;
  right: -80px;
  bottom: 0;
  ${mediaMin.md`
    display: block;
  `};

  ${mediaMin.lg`
    right: -100px;
  `};
`;

function SignUp() {
  return (
    <SectionWrapper>
      <RightCornerShapeImage
        src={`${config.RESOURCE_ORIGIN}/images/landing/sign-in-shape.png`}
      />
      <SignInLayoutWrapper>
        <HighFiveImage
          src={`${config.RESOURCE_ORIGIN}/images/landing/high-five.png`}
        />
        <ContentsWrapper>
          <MainCopySmall>Sign up</MainCopySmall>
          <MainCopyBig>
            Operating system for
            <br />
            freelancers and agencies
          </MainCopyBig>
          <SubCopy>Automate and streamline the end-to-end workflow</SubCopy>
          <InputWrapper>
            <SignUpInput />
            <Divider />
            <GoogleSignUpButton />
          </InputWrapper>
        </ContentsWrapper>
      </SignInLayoutWrapper>
    </SectionWrapper>
  );
}

export default SignUp;
